import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

import { REVENUE_SORT_COLUMNS } from './constants'

function TableClubCardHeader({ className, onFilter, sortBy, type }) {
  const { t: translate } = useTranslation()
  const nameValue = type === 'group' ? REVENUE_SORT_COLUMNS.CHANNEL_STORE_NAME : REVENUE_SORT_COLUMNS.STORE_NAME

  return (
    <div className={classNames('table-club-card-header', className)}>
      <Box className={classNames('row-wrapper flex-row', sortBy.order)}>
        <Box
          className={classNames('cell-title flex-row cursor-pointer', {
            'is-active': sortBy.value === nameValue,
          })}
          data-value={nameValue}
          onClick={onFilter}
        >
          <Box display="inline" className="category mobile-only" data-value={nameValue} onClick={onFilter} />

          <Box data-value={nameValue} onClick={onFilter}>
            {translate('search.table.shop')}
          </Box>
        </Box>

        <Box
          className={classNames('tablet-portrait-up-only', 'cell-category cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.CLUSTER,
          })}
          data-value={REVENUE_SORT_COLUMNS.CLUSTER}
          onClick={onFilter}
        >
          <Box display="inline" className="category" data-value={REVENUE_SORT_COLUMNS.CLUSTER} onClick={onFilter}>
            {translate('revenue.table.category')}
          </Box>
        </Box>

        <Box
          className={classNames('cell-clubRevenue cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.CLUB_REVENUE,
          })}
          data-value={REVENUE_SORT_COLUMNS.CLUB_REVENUE}
          onClick={onFilter}
        >
          {translate('tableClubCard.clubRevenue')}
        </Box>

        <Box
          className={classNames('cell-percentRevenue cursor-pointer', {
            'is-active': sortBy.value === REVENUE_SORT_COLUMNS.PERCENT_REVENUE_CLUB,
          })}
          data-value={REVENUE_SORT_COLUMNS.PERCENT_REVENUE_CLUB}
          onClick={onFilter}
        >
          {translate('tableClubCard.percentRevenue')}
        </Box>

        <Box
          className={classNames('cell-value cursor-pointer', { 'is-active': sortBy.value === REVENUE_SORT_COLUMNS.AVG_VALUE_CLUB })}
          data-value={REVENUE_SORT_COLUMNS.AVG_VALUE_CLUB}
          onClick={onFilter}
        >
          {translate('tableClubCard.avgValue')}
        </Box>

        <Box
          className={classNames('cell-newCards cursor-pointer', { 'is-active': sortBy.value === REVENUE_SORT_COLUMNS.NEW_CARDS })}
          data-value={REVENUE_SORT_COLUMNS.NEW_CARDS}
          onClick={onFilter}
        >
          {translate('tableClubCard.newCards')}
        </Box>
      </Box>
    </div>
  )
}

TableClubCardHeader.propTypes = {
  className: PropTypes.string,
  onFilter: PropTypes.func,
  sortBy: PropTypes.object,
  type: PropTypes.string,
}

export default TableClubCardHeader
